import { render, staticRenderFns } from "./AdminActions.vue?vue&type=template&id=0ae9b72e"
import script from "./AdminActions.vue?vue&type=script&lang=js"
export * from "./AdminActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports